/**
 * User: liliana
 * Date: 11/10/14
 * Time: 3:53 PM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

"use strict";

// ---------------------------------------------------
// Load Super Class
var SoaCollection = require('bunsen/collections/SoaCollection');

// ---------------------------------------------------
// Module Definition

/**
 * @class Attributes
 * @extends SoaCollection
 */
var Attributes = module.exports = SoaCollection.extend();

// ---------------------------------------------------
// Dependencies

var _ = require('underscore');
var SV = require('server-vars');
var Attribute = require('bunsen/models/inventory/Attribute');
var ItemAttributes = require('bunsen/collections/inventory/ItemAttributes');

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(Attributes.prototype, {
    model : Attribute,

    /**
     * Recursively flattens entire data via lookup key
     * @param {Attributes} attributeCollection
     * @param {string} [key='child']
     * @returns {Attribute[]}
     */
    flatten: function (attributeCollection, key) {
        var self = this;
        var list = [];
        attributeCollection = attributeCollection || this;
        key = key || 'child';

        if (attributeCollection.length) {

            attributeCollection.each(function (attribute) {
                attribute = attribute.clone();
                var children = attribute.get(key) || [];
                var i;

                // adds item to list with 'key' property omitted
                if (children.length) {
                    attribute.unset(key);
                }

                list.push(attribute);

                list = list.concat(self.flatten(children, key));
            });
        }
        return list;
    },

    /**
     * Goes down specified number of levels before flattening all child nodes
     * @param {number} level
     * @param {Attributes} [attributeCollection=this]
     * @param {string} [key='child']
     * @returns {Attribute[]}
     */
    flattenAtLevel: function (level, attributeCollection, key) {
        var i;
        var children;
        var list = [];

        if (arguments.length === 2) {
            if (typeof attributeCollection === 'string') {
                key = attributeCollection;
            }
        }

        attributeCollection = attributeCollection instanceof Attributes ? attributeCollection : this;
        key = key || 'child';

        level--;

        if (level < 0) {
            // I don't think this should ever happen...
            console.warn('Level is < 0. Failing gracefully by returning whatever is in data.');
            return attributeCollection;
        }

        for (i = 0; i < attributeCollection.length; i++) {
            children = attributeCollection.at(i).get(key) || [];

            if (level === 0) {

                attributeCollection.at(i).unset(key);
                list.push(attributeCollection.at(i));

                if (children.length) {
                    list = list.concat(this.flatten(children, key));
                }
            } else {
                if (children.length) {
                    attributeCollection.at(i).set(key, this.flattenAtLevel(level, children, key));
                }
            }
        }
        return list.length ? list : attributeCollection.models;
    },

    toItemAttributes: function(omitChild) {
        var attributesArr = [];
        this.each(function (attribute) {
            attributesArr.push(attribute.toItemAttribute(omitChild));
        });
        return attributesArr;
    },

    getItemAttributesCollection: function (options) {
        var attributesArr = [];
        options = options || {};

        _.each(this.flatten(), function (attribute) {
            attributesArr.push(attribute.toItemAttribute(true));
        });

        return new ItemAttributes(attributesArr, options);
    }
});

// ---------------------------------------------------
// Define Module Static Properties

_.extend(Attributes, {
    _attributesByKey: {},

    getCollectionForKey: function (key) {
        if (!Attributes._attributesByKey[key]) {
            Attributes._attributesByKey[key] = new Attributes(SV.get('attributes.'+key));
        }
        return Attributes._attributesByKey[key];
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/Attributes.js
// module id = 1616
// module chunks = 63